

function LibroPublicidad({width="315", height="560"}) {
  return (
    <iframe width={width} height={height}
src="https://www.youtube.com/embed/OZAHlYQdaUk"
title="YouTube video player"
frameborder="0"
allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
allowfullscreen></iframe>


  );
}

export default LibroPublicidad;
